<template>
  <main class="guests-page">
    <div class="guests-page__head">
      <h1 class="guests-page__title">Modifica ospite</h1>
      <router-link to="/guests" class="villa-btn villa-btn--ghost">
        <i class="fa-solid fa-arrow-left"></i> Torna alla lista
      </router-link>
    </div>

    <div v-if="loading" class="guests-loading">Caricamento…</div>

    <GuestForm
      v-else
      :initial="guest"
      submit-label="Salva modifiche"
      :submitting="submitting"
      @submit="onSubmit"
      @cancel="goBack"
    />
  </main>
</template>

<script>
import { mapActions } from "vuex";
import GuestForm from "@/components/GuestForm.vue";

export default {
  name: "EditGuestPage",
  components: { GuestForm },
  props: {
    id: { type: [String, Number], required: true },
  },
  data() {
    return { guest: null, loading: true, submitting: false };
  },
  methods: {
    ...mapActions(["fetchGuestById", "updateGuest"]),
    goBack() {
      this.$router.push("/guests");
    },
    async load() {
      this.loading = true;
      try {
        this.guest = await this.fetchGuestById(this.id);
      } catch (err) {
        this.$toast.error(err?.response?.data?.error || "Ospite non trovato.");
        this.$router.push("/guests");
      } finally {
        this.loading = false;
      }
    },
    async onSubmit(payload) {
      this.submitting = true;
      try {
        await this.updateGuest({ guestId: this.id, payload });
        this.$toast.success("Ospite aggiornato con successo!");
        this.$router.push({ name: "guest-detail", params: { id: this.id } });
      } catch (err) {
        this.$toast.error(
          err?.response?.data?.error ||
            err?.response?.data?.details ||
            "Errore durante l'aggiornamento dell'ospite."
        );
      } finally {
        this.submitting = false;
      }
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style src="@/css/GuestsPage.css" />
